var vw = document.getElementById('hide-while-loading')
vw.classList.add('hide');
function waitForElements(callback) {
    var checkInterval = setInterval(function() {
        var twt = document.getElementById('ProductSelect-6805587394725-option-supply-2+Week+Starter+Pack');
        var sms = document.getElementById('ProductSelect-6805587394725-option-supply-6+Month+Subscription');
        var smp = document.getElementById('ProductSelect-6805587394725-option-supply-6+Month+Programme');
        var oneTime = document.getElementById('product_6805587394725_onetime');
        var subSave = document.getElementById('product_6805587394725_subsave');
        var rcPopup = document.getElementById('subscription_purchase');
        var otPopup = document.getElementById('one_time_purchase');
        var rc_onetime = document.getElementsByClassName('rc_widget__option--onetime');
        var rc_subsave = document.getElementsByClassName('rc_widget__option--subsave');

        if (twt && sms && smp && oneTime && subSave && rcPopup && otPopup && rc_onetime.length > 0 && rc_subsave.length > 0) {
            clearInterval(checkInterval);
            callback(twt, sms, smp, oneTime, subSave, rcPopup, otPopup);
        }
    }, 100); // Check every 100 milliseconds
}

waitForElements(function(twt, sms, smp, oneTime, subSave, rcPopup, otPopup) {
    console.log("JS RUNNING");

    sms.onchange = function() {
        console.log("SMS", sms.value);
        rcPopup.classList.remove("hide");
        otPopup.classList.add("hide");
        subSave.click();
    };

    smp.onchange = function() {
        console.log("SMP", smp.value);
        rcPopup.classList.add("hide");
        otPopup.classList.remove("hide");
        oneTime.click();
    };

    twt.onchange = function() {
        console.log("TWT", twt.value);
        rcPopup.classList.add("hide");
        otPopup.classList.add("hide");
        oneTime.click();
    };
    twt.checked = true

    vw.classList.remove('hide')
});

